import { Fragment } from 'react'
import { Table, TableCell, TableHead, TableRow, styled } from '@mui/material'
import clsx from 'clsx'
import { Trans, useTranslation } from 'react-i18next'
import { Skeleton } from '@mui/material'
import { isNilOrEmpty } from 'packages/core'
import { RiskIndicator } from 'packages/eid-ui'


const StyledTableHeaderCell = styled(TableCell)({
    color: '#307fc1 !important',
    overflowWrap: 'break-word',
    maxWidth: '21rem',
    minWidth: 'fit-content',
    overflow: 'hidden',
    padding: '1.4rem 1rem',
    fontSize: '1.2rem',
    border: 'none',
    borderBottom: '0',
    '&:first-child': {
        paddingLeft: '3.1rem',
    },
    wordBreak: 'normal',
    textTransform: 'uppercase',
    lineHeight: '1.5rem',
    fontWeight: 'bold',
    backgroundImage:
        'linear-gradient(0deg, rgb(0, 0, 0, 0.02) 12.5%, rgb(255, 255, 255) 12.5%, rgb(255, 255, 255) 50%, rgb(0, 0, 0, 0.02) 50%, rgb(0, 0, 0, 0.02) 62.5%, rgb(255, 255, 255) 62.5%, rgb(255, 255, 255) 100%)',
    backgroundSize: '0.8rem 0.8rem',
    '& svg': {
        margin: '0rem !important',
    },

})

const StyledTableCells= styled(TableCell)({
    overflowWrap: 'break-word',
    maxWidth: '21rem',
    minWidth: 'fit-content',
    overflow: 'hidden',
    padding: '1.4rem 1rem',
    fontSize: '1.3rem',
    border: 'none',
    borderBottom: '0',
    '&:first-child': {
        paddingLeft: '3.1rem',
    },

})



export interface FunctionalAccessItemListProps {
    latestData: any
    isFetching: boolean
}

const FunctionalAccessItemList: React.FC<FunctionalAccessItemListProps> = ({
    latestData,
    isFetching,
}) => {
    const { t } = useTranslation()

    const attributes = [
        {
            style: {
                width: '12rem',
            },
            label: t('RiskLevel'),
            resolve: (item: any) => (
                <RiskIndicator
                    variant={item.riskLevel}
                    label={t(`${item.riskLevel}Risk`)}
                ></RiskIndicator>
            ),
        },
        {
            name: 'functionTypeFriendlyName',
            label: t('FunctionType'),
        },
        {
            name: 'localFunctionFriendlyName',
            label: t('FunctionName'),
        },
        {
            name: 'description',
            label: t('Description'),
        },
    ]

    const headings = attributes.map((a) => a.label)

    return (
        <Table style={{backgroundColor: '#ffffff'}}>
            <TableHead>
                <TableRow style={{border: 'solid 0.1rem #efeff1'}}>
                    {headings.map((heading, index) => (
                        <StyledTableHeaderCell
                            key={index}
                        >
                            {heading}
                        </StyledTableHeaderCell>
                    ))}
                </TableRow>
                {isFetching ? (
                    <TableRow>
                        <StyledTableCells colSpan={headings.length + 2}>
                            <Skeleton
                                animation="wave"
                                variant="rectangular"
                                height={64}
                            />
                        </StyledTableCells>
                    </TableRow>
                ) : latestData?.data?.length === 0 ? (
                    <TableRow style={{border: 'solid 0.1rem #efeff1'}} hover={false}>
                        <StyledTableCells
                            colSpan={headings.length + 2}
                            style={{ textAlign: 'center'}}
                        >
                            <Trans i18nKey="NoDataFound" />
                        </StyledTableCells>
                    </TableRow>
                ) : (
                    <>
                        {latestData?.data?.map((item: any) => (
                            <Fragment key={item.id}>
                                <TableRow style={{border: 'solid 0.1rem #efeff1'}}>
                                    {attributes.map((a, index) => (
                                        <StyledTableCells
                                            key={`${item.id}${index}`}
                                            style={a.style}
                                        >
                                            {a.resolve
                                                ? a.resolve(item)
                                                : !isNilOrEmpty(item[a.name])
                                                ? item[a.name]
                                                : '-'}
                                        </StyledTableCells>
                                    ))}
                                </TableRow>
                            </Fragment>
                        ))}
                    </>
                )}
            </TableHead>
        </Table>
    )
}

export default FunctionalAccessItemList
